export default __webpack_public_path__ + "static/media/eduRed.a44e7ceb.svg";